/** @jsxImportSource @emotion/react */
import { AndroidFilled, AppleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { LinkDownloadFileApk, LinkDownloadFileIOS } from "constants/apk";
import { useAppDispatch } from "hooks/app-hook";
import { useTranslation } from "react-i18next";
import { setOpenModal } from "store/modal";
import { ModalTypeValue } from "types/modal";

import WrapperForm from "../WrapperForm";
import { ModalDownloadStyle } from "./index.style";
function ModalDownload() {
  const { t } = useTranslation(["download"]);

  const dispatch = useAppDispatch();

  return (
    <Modal
      open={true}
      closable={false}
      forceRender
      onCancel={() => dispatch(setOpenModal(ModalTypeValue.Close))}
      css={ModalDownloadStyle.modalContainer}
      footer={<></>}
      centered
      focusTriggerAfterClose={false}
      style={{ width: 300, height: 200 }}
    >
      <WrapperForm
        title={t("DownloadAPP")}
        formType={ModalTypeValue.Login}
        body={
          <div css={ModalDownloadStyle.formContainer}>
            <div css={[ModalDownloadStyle.center, ModalDownloadStyle.box]}>
              <div
                css={[ModalDownloadStyle.center, ModalDownloadStyle.boxBorder]}
                onClick={() => window.open(LinkDownloadFileApk, "_blank")}
              >
                <AndroidFilled css={[ModalDownloadStyle.icon]} />
                <span>{t("DownloadAPP")}</span>
              </div>
              <div
                css={[ModalDownloadStyle.center, ModalDownloadStyle.boxBorder]}
                onClick={() => window.open(LinkDownloadFileIOS, "_blank")}
              >
                <AppleFilled css={[ModalDownloadStyle.icon]} />
                <span>{t("DownloadAPP")}</span>
              </div>
            </div>
          </div>
        }
      />
    </Modal>
  );
}

export default ModalDownload;
